<template>
    <component
        :is="tag"
        ref="tooltip"
        class="overflow-hidden"
        :style="`line-clamp: ${lines};`"
        style="display: -webkit-box; box-orient: vertical"
        @mouseenter="mouseEnterRef"
        @mouseleave="mouseLeaveRef"
    >
        <span
            v-if="html"
            v-html="value"
        />

        <template v-else>
            {{ value }}
        </template>
    </component>
</template>

<script>
import debounce from "lodash/debounce"
import { html2text } from "~/lib/utils"
import { usePopupActions } from "front-toolkit/plugins/PopupPlugin"
import ToolTipElement from "./ToolTipElement"

export default {
    props: {
        text: {
            type: String,
            default: "",
        },

        lines: {
            type: Number,
            default: 2,
        },

        tag: {
            type: String,
            default: "div",
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        html: Boolean,
    },

    emits: ["mounted"],

    setup() {
        const { pushPopup } = usePopupActions()
        return { pushPopup }
    },

    data() {
        return {
            onRef: false,
            onTooltip: false,
            popup: null,
        }
    },

    computed: {
        hasEllipsis() {
            const THRESHOLD = 5
            return this.$el.scrollHeight - this.$el.clientHeight > THRESHOLD
        },

        value() {
            if (this.html) {
                return this.text
            } else {
                return html2text(this.text)
            }
        },
    },

    watch: {
        disabled() {
            if (this.disabled) {
                this.hidePopUp()
            }
        },
    },

    created() {
        this.showPopUp = debounce(this.showPopUp, 500)
    },

    mounted() {
        this.$emit("mounted", this.$el)
    },

    beforeUnmount() {
        this.showPopUp.cancel()
    },

    methods: {
        mouseEnterRef() {
            if (this.disabled) return
            if (!this.hasEllipsis) return
            this.onRef = true
            this.showPopUp()
        },

        mouseLeaveRef() {
            this.onRef = false
            this.showPopUp.cancel()
            if (!this.onTooltip) {
                this.hidePopUp()
            }
        },

        showPopUp() {
            if (this.popup?.pop()) return

            this.popup = this.pushPopup({
                component: ToolTipElement,
                ref: this.$refs.tooltip,
                props: {
                    text: this.text,
                    html: this.html,
                },
                on: {
                    exit: () => {
                        this.onTooltip = false
                        if (!this.onRef) {
                            this.hidePopUp()
                        }
                    },
                    enter: () => {
                        this.onTooltip = true
                    },
                },
                yClamp: true,
                yPadding: 8,
                position: "bottom",
                onWheelOutside: () => this.hidePopUp(),
            })
        },

        hidePopUp() {
            this.popup?.pop()
        },
    },
}
</script>
